import React, { Component } from "react";
import { fire, auth } from "../../../firebase/index";
//? English Version
import AuditTrail from "../../../assets/img/tutorialimages/viewAuditTrailGuide.png";
//? Japanese Version
import AuditTrail1Jap from "../../../assets/img/tutorialimages/viewAuditTrailGuide1_Jap.png";
import AuditTrail2Jap from "../../../assets/img/tutorialimages/viewAuditTrailGuide2_Jap.png";
import AuditTrail3Jap from "../../../assets/img/tutorialimages/viewAuditTrailGuide3_Jap.png";

class AuditTrailGuide extends Component {
  constructor(props) {
    super(props);

    this.state = {
      language: "en",
    };

    this.getHelper = this.getHelper.bind(this);
  }

  componentDidMount() {
    if (auth.currentUser !== null) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .on("value", this._langCb = (snapshot) => {
          this.setState({
            language: snapshot.val(),
          });
        });
    }
  }

  getHelper() {
    if (this.state.language === "en") {
      return (
        <div
          style={{
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={AuditTrail}
            alt="AuditTrail"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    } else if (this.state.language === "ja") {
      return (
        <div>
          <div
            style={{
              width: "80%",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <img
              className="imgStyle"
              src={AuditTrail1Jap}
              alt="AuditTrail"
              style={{
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
                height: "100%",
              }}
            />
          </div>
          <div
            style={{
              width: "80%",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <img
              className="imgStyle"
              src={AuditTrail2Jap}
              alt="AuditTrail"
              style={{
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
                height: "100%",
              }}
            />
          </div>
          <div
            style={{
              width: "80%",
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            <img
              className="imgStyle"
              src={AuditTrail3Jap}
              alt="AuditTrail"
              style={{
                width: "100%",
                marginLeft: "auto",
                marginRight: "auto",
                height: "100%",
              }}
            />
          </div>
        </div>
      );
    } else if (this.state.language === "es") {
      return (
        <div
          style={{
            width: "80%",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <img
            className="imgStyle"
            src={AuditTrail}
            alt="AuditTrail"
            style={{
              width: "100%",
              marginLeft: "auto",
              marginRight: "auto",
              height: "100%",
            }}
          />
        </div>
      );
    }
  }
  componentWillUnmount() {
    if (auth.currentUser !== null && this._langCb) {
      fire
        .database()
        .ref("userSettings")
        .child(auth.currentUser.uid)
        .child("language")
        .off("value", this._langCb);
    }
  }

  render() {
    return this.getHelper();
  }
}

export default AuditTrailGuide;
